import React, { ReactNode } from 'react';
import { isEqual } from 'lodash';
import type { TFunction } from 'i18next';
import type { ChangeEntry } from './SaveHeaderContext';

const renderValue = (v: unknown): ReactNode => {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'boolean') return v ? '✓' : '✗';
  if (typeof v === 'string' || typeof v === 'number') return String(v);
  return React.createElement(
    'pre',
    { style: { margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12 } },
    JSON.stringify(v, null, 2),
  );
};

export const defaultTopLevelDiff = <V extends Record<string, any>>(
  values: V,
  initialValues: V,
  t: TFunction,
): ChangeEntry[] => {
  const keys = new Set<string>([...Object.keys(values || {}), ...Object.keys(initialValues || {})]);
  const changes: ChangeEntry[] = [];
  keys.forEach((key) => {
    const from = initialValues?.[key];
    const to = values?.[key];
    if (isEqual(from, to)) return;
    const translated = t(`fields.${key}`, { defaultValue: key });
    changes.push({ label: translated, from: renderValue(from), to: renderValue(to) });
  });
  return changes;
};
